module.exports = __webpack_public_path__ + "heart-twilight-neon.1af20431822f1ab5b005.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/heart-twilight-neon.svg
// module id = ../../../../../src/assets/img/heart-twilight-neon.svg
// module chunks = main